import { render, staticRenderFns } from "./TypographyDoc.vue?vue&type=template&id=52da89ae&scoped=true&"
import script from "./TypographyDoc.vue?vue&type=script&lang=js&"
export * from "./TypographyDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da89ae",
  null
  
)

export default component.exports